export default __webpack_public_path__ + "static/media/SR2030_Mobile.273e0653.png";